const FORM_PATTERNS = {
  NAME: /^(?! )(?=[A-Za-z ]*$)[A-Za-z]+( [A-Za-z]+)*[^ ]$/,
  EMAIL:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
}

const FORM_ERRORS = {
  REQUIRED: 'This field is required',
  MIN_LENGTH: (length) => `At least ${length} characters`,
  MAX_LENGTH: (length) => `Not more than ${length} characters`,
  NAME: 'Invalid name. No spaces at the start or end and only latin letters',
  EMAIL: 'Please, enter a valid email',
}

export { FORM_ERRORS, FORM_PATTERNS }
